import { I18nComponente } from "@/types/gerais"

export const TPainelDeEstatisticasi18n: I18nComponente = {
  "pt-BR": {
    projetosSelecionados: "projetos selecionados",
    gruposDeProjetos: "grupos de projetos",
    projetos: "projetos"
  },
  "es-CO": {
    projetosSelecionados: "proyectos seleccionados",
    gruposDeProjetos: "grupos de proyectos",
    projetos: "proyectos"
  }
}
